import { render, staticRenderFns } from "./OrderNotificationPopup.vue?vue&type=template&id=11ea88d0"
import script from "./OrderNotificationPopup.vue?vue&type=script&lang=js"
export * from "./OrderNotificationPopup.vue?vue&type=script&lang=js"
import style0 from "./OrderNotificationPopup.vue?vue&type=style&index=0&id=11ea88d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports